import React from "react";
import { ShieldCheck } from "lucide-react";

const SECTIONS = [
  {
    title: "1. Platform Nature",
    body: "Credit Kendra (\u201cCredit Kendra\u201d, \u201cwe\u201d, \u201cus\u201d) operates a referral and lead-generation platform. We are NOT a bank, NBFC, lender, broker, asset management company (AMC), or insurance provider. All financial products listed on this platform are offered by respective regulated partner institutions. We do not provide financial advice, and nothing on this platform constitutes an offer, solicitation, or recommendation.",
  },
  {
    title: "2. Eligibility",
    body: "You must be at least 18 years of age and a resident of India to use this platform. By registering, you confirm that all information you provide is accurate, complete, and up to date.",
  },
  {
    title: "3. Referral Partner Terms",
    body: "Referral partners (Advisers) are independent freelancers and not employees of Credit Kendra. Partners must comply with the Partner Declaration & Terms accepted at registration, including customer consent, no misrepresentation, use of approved campaign material, and data privacy obligations.",
  },
  {
    title: "4. Rewards & Payouts",
    body: "Rewards are subject to verified conversions confirmed by the respective brand/partner report. Pending rewards become payable only after validation. Credit Kendra reserves the right to reject fraudulent, duplicate, or invalid activity and to recover any incentive already paid against such activity. Payout rates, campaign availability, and terms may change without prior notice for future transactions. There is no guaranteed income or assured approval.",
  },
  {
    title: "5. KYC & Withdrawals",
    body: "Withdrawals require completed and approved KYC. Minimum withdrawal limits, processing times, and applicable deductions (including signup bonus redemption rules) are governed by the platform settings in effect at the time of the withdrawal request.",
  },
  {
    title: "6. Prohibited Activities",
    body: "You must not: (a) provide false or misleading information; (b) create fake, duplicate, or self-generated leads; (c) misuse customer data, OTPs, or KYC documents; (d) misrepresent yourself as an employee or representative of Credit Kendra or any financial institution; (e) violate any applicable Indian law or regulation.",
  },
  {
    title: "7. Intellectual Property",
    body: "All content, logos, creatives, and campaign material on this platform are the property of Credit Kendra or its partners. You may not copy, modify, or distribute them without written authorization.",
  },
  {
    title: "8. Limitation of Liability",
    body: "Credit Kendra is not liable for any direct, indirect, incidental, or consequential damages arising from use of the platform, including but not limited to loss of rewards, campaign suspension, or partner-side rejections.",
  },
  {
    title: "9. Termination",
    body: "We may suspend or terminate your access for fraud, policy violation, misuse, or compliance concerns, subject to applicable law and contractual terms.",
  },
  {
    title: "10. Changes to Terms",
    body: "We may update these Terms of Service from time to time. The latest version will be posted on this page. Continued use of the platform after changes constitutes acceptance.",
  },
  {
    title: "11. Governing Law",
    body: "These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in Mumbai, Maharashtra.",
  },
  {
    title: "12. Contact",
    body: "For questions about these Terms, contact us at support@creditkendra.com or WhatsApp +91 98235 67811. Registered office: Credit Kendra, 302, Gokul Plaza, Veer Savarkar Marg, above Central Bank of India, Gawad Wadi, Virar East, Virar, Maharashtra 401305.",
  },
];

export default function TermsOfService() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid="terms-of-service-page">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 rounded-xl bg-teal-50 text-teal-600 flex items-center justify-center">
          <ShieldCheck className="w-5 h-5" />
        </div>
        <h1 className="font-display text-4xl font-extrabold text-[#0B223D] dark:text-white">Terms of Service</h1>
      </div>
      <p className="text-sm text-slate-400 mb-10">Last updated: October 2026 · Credit Kendra</p>

      <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-2xl p-5 mb-8">
        <p className="text-sm text-amber-800 dark:text-amber-300 leading-relaxed">
          <strong>Important:</strong> Credit Kendra is a referral &amp; lead-generation platform. We are not a bank, NBFC, lender, broker, AMC, or insurer. All financial products are offered by respective regulated partners. No guaranteed income or assured approval.
        </p>
      </div>

      <div className="space-y-8">
        {SECTIONS.map((s) => (
          <div key={s.title}>
            <h2 className="font-display text-lg font-bold text-[#0B223D] dark:text-white mb-2">{s.title}</h2>
            <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed">{s.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
